<template>
  <div class="member-info">
    <div class="member-status" v-show="view.current === view.layout.STATUS">
      <section class="border-top border-dark">
        <div class="row gx-5 justify-content-center" v-if="user && currentRank">
          <div class="col-md-6 pt-5 pb-5 loft-col">
            <div class="title">會員資料</div>
            <div class="mt-3">
              <div class="border border-dark mb-3">
                <div class="row g-0 m-3">
                  <div class="col">E-mail</div>
                  <div class="col-auto">{{ user.email }}</div>
                </div>
              </div>
              <div class="border border-dark mb-3">
                <div class="row g-0 m-3">
                  <div class="col">姓名</div>
                  <div class="col-auto">{{ user.lastName }}{{ user.firstName || user.alias }}</div>
                </div>
              </div>
              <div class="border border-dark mb-3">
                <div class="row g-0 m-3">
                  <div class="col">手機號碼</div>
                  <div class="col-auto">{{ user.mobilePhone }}</div>
                </div>
              </div>
              <div class="border border-dark mb-3">
                <div class="row g-0 m-3">
                  <div class="col">生日</div>
                  <div class="col-auto">{{ userBirthday }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 pt-5 pb-5 loft-col">
            <div class="title">會員狀態</div>
            <div class="mt-3">
              <div class="border border-dark mb-3">
                <div class="row g-0 m-3">
                  <div class="col">會員等級</div>
                  <div class="col-auto"><span class="loft-text-highlight">{{ currentRank.name }}</span></div>
                </div>
              </div>
              <div class="border border-dark mb-3">
                <div class="row g-0 m-3">
                  <div class="col">會員折扣</div>
                  <div class="col-auto">{{ currentRank.discount && currentRank.discount !== 100 ? `${currentRank.discount}折` : '無' }}</div>
                </div>
              </div>
              <div class="border border-dark mb-3">
                <div class="row g-0 m-3">
                  <div class="col">累積消費</div>
                  <div class="col-auto">{{ util.toPriceFormat(user.consumeMoney) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-5">
          <button class="btn btn-dark ps-5 pe-5 pt-3 pb-3" @click="onEditClicked">修改會員資料</button>
        </div>
      </section>
    </div>
    <div class="member-edit" v-show="view.current === view.layout.EDIT">
      <section class="row justify-content-center" v-if="myUser">
        <div class="col-md-9">
          <div class="row">
            <div class="col-12">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" id="input-email" placeholder="E-mail" disabled :value="myUser.email">
                <label for="input-email">E-mail</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" :class="validation.lastName.class" id="input-lastname" placeholder="姓氏" maxlength="60" v-model="myUser.lastName">
                <label for="input-lastname">姓氏</label>
                <div class="invalid-feedback">{{ validation.lastName.feedback }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-floating mb-3">
                <input type="text" class="form-control" :class="validation.firstName.class" id="input-firstname" placeholder="名字" maxlength="60" v-model="myUser.firstName">
                <label for="input-firstname">名字</label>
                <div class="invalid-feedback">{{ validation.firstName.feedback }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-floating mb-3">
                <input type="tel" class="form-control" :class="validation.mobilePhone.class" id="input-phone" placeholder="手機號碼" maxlength="10" v-model="myUser.mobilePhone">
                <label for="input-phone">手機號碼</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-floating mb-3">
                <input id="input-birthday" class="form-control" :class="validation.birthday.class" placeholder="生日" :value="birthday" disabled>
                <label for="input-birthday">生日</label>
                <div class="invalid-feedback">{{ validation.birthday.feedback }}</div>
              </div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-12 d-flex justify-content-center"><button class="btn btn-dark w-50" @click="onSetUserClicked">確認</button></div>
            <div class="col-12 d-flex justify-content-center mt-3"><button class="btn p-0 w-50" @click="onCancelClicked">取消</button></div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import userApi from '@/api/user.js'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'MemberInfo',
  data: function () {
    return {
      myUser: null,
      birthday: null,
      ranks: [
        { id: 0, name: '普通會員', threshold: 0, discount: 100 },
        { id: 5, name: '一級會員', threshold: 30000, discount: 95 },
        { id: 4, name: '二級會員', threshold: 300000, discount: 9 },
        { id: 6, name: '三級會員', threshold: 500000, discount: 88 },
        { id: 7, name: '四級會員', threshold: 1000000, discount: 85 }
      ],
      view: {
        layout: {
          STATUS: 0,
          EDIT: 1
        },
        current: 0
      },
      isValidated: false,
      validation: {
        firstName: { class: null, feedback: null },
        lastName: { class: null, feedback: null },
        mobilePhone: { class: null, feedback: null },
        birthday: { class: null, feedback: null }
      }
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'authId'
    ]),
    util: function () {
      return util
    },
    userBirthday: function () {
      let ret = null
      if (this.user && this.user.birthday) {
        const birDate = new Date(this.user.birthday)
        ret = `${birDate.getMonth() + 1}/${birDate.getDate()}`
      }
      return ret
    },
    currentRank: function () {
      var ret = null
      if (this.user) {
        var self = this
        ret = this.ranks.find(e => e.id === self.user.userRank)
      }
      return ret
    },
    nextRank: function () {
      var ret = null
      if (this.user) {
        for (var i = 0; i < this.ranks.length; ++i) {
          if (this.ranks[i].id === this.user.userRank && i + 1 < this.ranks.length) {
            ret = this.ranks[i + 1]
            break
          }
        }
      }
      return ret
    }
  },
  watch: {
    'myUser.firstName': function (value) {
      this.validation.firstName.class = null
    },
    'myUser.lastName': function (value) {
      this.validation.lastName.class = null
    },
    'myUser.mobilePhone': function (value) {
      this.validation.mobilePhone.class = null
    },
    birthday: function (value) {
      this.validation.birthday.class = null
    }
  },
  created: function () {
    // get username
    this.myUser = Object.assign({}, this.user)
    if (!this.myUser.firstName) {
      this.myUser.firstName = this.myUser.alias
    }
    // get birthday
    const birDate = new Date(this.myUser.birthday)
    this.birthday = `${birDate.getMonth() + 1}/${birDate.getDate()}`
  },
  mounted: function () {
    // init datepicker
    var self = this
    console.log('init datepicker')
    $('#input-birthday').datepicker({
      dateFormat: 'mm/dd',
      yearSuffix: '',
      onSelect: function (date) {
        self.birthday = date
      }
    })
  },
  methods: {
    ...mapMutations([
      'setUser',
      'setAlert',
      'signOut'
    ]),
    apiSetUser: function () {
      if (!this.myUser) {
        return
      }
      /*
      if (this.birthday) {
        this.myUser.birthday = new Date(`${new Date().getFullYear()}/${this.birthday}`).getTime()
      }
      */
      var self = this
      userApi.setUser(this.myUser, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            self.setAlert({ type: constant.ALERT_TYPE.ERR, msg: `執行發生錯誤：${rspData} (${err})` })
          }
          return
        }
        self.setUser(self.myUser)
        self.view.current = self.view.layout.STATUS
        self.setAlert({ type: constant.ALERT_TYPE.INFO, msg: '修改完成' })
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      })
    },
    onEditClicked: function () {
      this.view.current = this.view.layout.EDIT
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    },
    onCancelClicked: function () {
      this.view.current = this.view.layout.STATUS
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    },
    onSetUserClicked: function () {
      // input check
      this.isValidated = true
      // check name
      if (!this.myUser.firstName) {
        this.isValidated = false
        this.validation.firstName.class = 'is-invalid'
        this.validation.firstName.feedback = '請輸入名字'
      } else {
        this.validation.firstName.class = null
      }
      if (!this.myUser.lastName) {
        this.isValidated = false
        this.validation.lastName.class = 'is-invalid'
        this.validation.lastName.feedback = '請輸入姓氏'
      } else {
        this.validation.lastName.class = null
      }
      // check phone
      if (this.myUser.mobilePhone === null) {
        this.isValidated = false
        this.validation.mobilePhone.class = 'is-invalid'
        this.validation.mobilePhone.feedback = '請輸入您的手機號碼'
      } else if (!this.myUser.mobilePhone.match(/^09\d{8}$/)) {
        this.isValidated = false
        this.validation.mobilePhone.class = 'is-invalid'
        this.validation.mobilePhone.feedback = '不正確的手機號碼格式'
      } else {
        this.validation.mobilePhone.class = null
      }
      // check birthday
      /*
      if (!this.birthday) {
        this.isValidated = false
        this.validation.birthday.class = 'is-invalid'
        this.validation.birthday.feedback = '請輸入生日'
      } else {
        this.validation.birthday.class = null
      }
      */

      if (!this.isValidated) {
        return
      }

      this.apiSetUser()
    }
  }
}
</script>

<style scoped>
.username {
  font-size: 2rem;
  font-family: 'Noto Serif TC', serif;
  font-weight: 700;
}
.email {
  font-size: 1.125rem;
}
.title {
  font-size: 1.3rem;
  font-weight: 500;
}
.col.title {
  font-weight: 400;
}
.content {
  font-weight: 500;
}
.member-status {
  font-weight: 500;
}
.form-control[readonly] {
  background: #fff;
}

@media screen and (max-width: 767px) {
  .btn {
    width: 100% !important;
  }
}
@media screen and (min-width: 768px) {
  .loft-col:last-child {
    border-left: 1px solid;
    border-color: var(--bs-dark);
  }
}
</style>
